import type { SVGProps } from 'react';
const SvgHardware = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#hardware_svg__a)">
      <path d="m18 3-3 3V3H9C6.24 3 4 5.24 4 8h5v3h6V8l3 3h2V3h-2ZM9 13v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-7H9Z" />
    </g>
    <defs>
      <clipPath id="hardware_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHardware;
